import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-teal-500 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <img 
              src="https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/462af14e58567737405a156b1955e865.png"
              alt="NovaRadiance Distribution Logo"
              className="h-24 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-sm text-white/90 leading-relaxed">
              Leading distributor of premium infrared and red light therapy products. Elevating health and wellness through innovative technology.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <p className="text-gray-800 text-sm mb-2">7204546331</p>
            <p className="text-gray-800 text-sm mb-2">
              <a href="mailto:Info@NovaradianceDist.com" className="hover:text-teal-600 transition-colors cursor-pointer">
                Info@NovaradianceDist.com
              </a>
            </p>
            <p className="text-gray-800 text-sm mb-6">1500 N Grant St Ste R, Denver, CO 80203, United States</p>
            
            <div className="border-t border-gray-400 pt-6">
              <div className="flex space-x-4">
                <a href="https://www.facebook.com" target="_blank" rel="noreferrer noopener" className="w-8 h-8 flex items-center justify-center cursor-pointer" aria-label="Facebook">
                  <img src="https://static.wixstatic.com/media/64a918_d9471de294d741f48b2e2b25d078e7a8~mv2.png/v1/fill/w_27,h_27,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/64a918_d9471de294d741f48b2e2b25d078e7a8~mv2.png" alt="Facebook" className="w-full h-full" />
                </a>
                <a href="https://www.instagram.com" target="_blank" rel="noreferrer noopener" className="w-8 h-8 flex items-center justify-center cursor-pointer" aria-label="Instagram">
                  <img src="https://static.wixstatic.com/media/64a918_8f522ffdce4e48b09136b1486bb2822a~mv2.png/v1/fill/w_27,h_27,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/64a918_8f522ffdce4e48b09136b1486bb2822a~mv2.png" alt="Instagram" className="w-full h-full" />
                </a>
                <a href="https://x.com" target="_blank" rel="noreferrer noopener" className="w-8 h-8 flex items-center justify-center cursor-pointer" aria-label="X">
                  <img src="https://static.wixstatic.com/media/2e2a49_e38ff9c38b8e41bb8422e115dc67df4a~mv2.png/v1/fill/w_27,h_27,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/2e2a49_e38ff9c38b8e41bb8422e115dc67df4a~mv2.png" alt="X" className="w-full h-full" />
                </a>
                <a href="https://www.tiktok.com" target="_blank" rel="noreferrer noopener" className="w-8 h-8 flex items-center justify-center cursor-pointer" aria-label="TikTok">
                  <img src="https://static.wixstatic.com/media/2e2a49_aaa72a7b672b4ade9ee8643cee872256~mv2.png/v1/fill/w_27,h_27,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/2e2a49_aaa72a7b672b4ade9ee8643cee872256~mv2.png" alt="TikTok" className="w-full h-full" />
                </a>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <div className="space-y-2">
              <p className="text-gray-800 text-sm">
                <Link to="/privacy-policy" className="hover:text-teal-600 transition-colors cursor-pointer">Privacy Policy</Link>
              </p>
              <p className="text-gray-800 text-sm">
                <Link to="/accessibility" className="hover:text-teal-600 transition-colors cursor-pointer">Accessibility Statement</Link>
              </p>
              <p className="text-gray-800 text-sm">
                <Link to="/shipping" className="hover:text-teal-600 transition-colors cursor-pointer">Shipping Policy</Link>
              </p>
              <p className="text-gray-800 text-sm">
                <Link to="/terms" className="hover:text-teal-600 transition-colors cursor-pointer">Terms & Conditions</Link>
              </p>
              <p className="text-gray-800 text-sm">
                <Link to="/refund" className="hover:text-teal-600 transition-colors cursor-pointer">Refund Policy</Link>
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-400 mt-12 pt-8">
          <p className="text-gray-700 text-xs text-center">
            © 2035 by NovaRadiance Distribution L.L.C. <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-teal-600 transition-colors cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
